;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import fetchAPI from '@/lib/fetch-api';
import type { CurrentKYCVerification, DemoOverageRemaining } from '@/types/kyc';

/**
 * Fetches the authenticated user's current KYC verification with granted permissions.
 * Shared by the React Query hook (client) and server-side prefetching.
 * @throws {Error} If the API request fails
 * @returns {Promise<CurrentKYCVerification | null>} The current KYC verification, or null if none exists
 */
export async function getCurrentKycVerification(): Promise<CurrentKYCVerification | null> {
  const response = await fetchAPI<CurrentKYCVerification | null>('/kyc-verification/current', {
    method: 'GET',
  });

  if (!response.success && (!response.status || ![200, 201].includes(response.status))) {
    throw new Error(response.error || response.message || 'Failed to get current KYC verification');
  }

  return response.data ?? null;
}

/**
 * Fetches the authenticated user's remaining demo overage allowance for a given currency.
 * Returns null in `data.remaining_amount` when the user is not demo-verified (no cap applies).
 * @param {number} currencyId - The currency in which the remaining allowance is returned
 * @throws {Error} If the API request fails
 */
export async function getDemoOverageRemaining(currencyId: number): Promise<DemoOverageRemaining> {
  const response = await fetchAPI<DemoOverageRemaining>(
    `/kyc-verification/demo-overage/remaining?currency_id=${currencyId}`,
    { method: 'GET' }
  );

  if (!response.success && (!response.status || ![200, 201].includes(response.status))) {
    throw new Error(response.error || response.message || 'Failed to fetch demo overage remaining');
  }

  return response.data!;
}
